import { useEffect, useRef, useState } from "react";
import { Menu } from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { ReactSVG } from "react-svg";
import {
  PoSystemIcon,
  AdminIcon,
  SupplierPOIcon,
  NissanSupplierIcon,
  DashboardIcon,
} from "config/IconConfig";
import { loadState } from "library/helpers/sessionStorage";
import { useDispatch, useSelector } from "react-redux";
import { getPermissionsRequest } from "redux/masterData/actions";
import {
  fetchAllCustomersRequest,
  fetchAllVendorsRequest,
} from "redux/allCustomersVendors/actions";
import { fetchAllUsersRequest } from "redux/allUsers/actions";
import { config } from "config/site.config";
import { RootState } from "redux/store";
import { setLoggedInUserInfo } from "redux/users/actions";
import * as S from "./styles";

interface SiderMenuProps {
  setCollapsed: (collapsed: boolean) => void;
}

type IconMap = {
  [key: string]: string;
};

const iconMap: IconMap = {
  Dashboard: DashboardIcon,
  Users: AdminIcon,
  "Order Activity": PoSystemIcon,
  Configuration: SupplierPOIcon,
  LtlCustomers: NissanSupplierIcon,
  "Invoice Activity": PoSystemIcon,
  Settings: AdminIcon,
  SettingsNew: AdminIcon,
};

const getIconName = (key: string): string => {
  return iconMap[key];
};

const SiderMenu = ({ setCollapsed }: SiderMenuProps) => {
  const initialized = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState<string[]>(["users"]);
  const menuItemsData = loadState("actualPermissionsList");
  const userInfoLocal = loadState("userInfo");
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: RootState) => state.users);

  useEffect(() => {
    if (userInfo) {
      if (!initialized.current) {
        initialized.current = true;
        dispatch(
          fetchAllCustomersRequest(config.getOrderEntryCustomersList, {
            pageNumber: 1,
            pageSize: 100,
            sortColumn: "customerId",
            sortOrder: "DESC",
            searchValue: "",
            isDropdown: true,
            goLiveDate: null,
          }),
        );
        dispatch(getPermissionsRequest(config.getPermissions));
        dispatch(
          fetchAllVendorsRequest(config.getOrderEntryVendorsList, {
            pageNumber: 1,
            pageSize: 100,
            sortColumn: "id",
            sortOrder: "DESC",
            searchValue: "",
            isDropdown: true,
            goLiveDate: null,
          }),
        );
        dispatch(fetchAllUsersRequest(config.getAllUsers));
      }
    } else {
      dispatch(setLoggedInUserInfo(userInfoLocal));
    }
  }, [userInfo]);

  const settingsChildRoutes = [
    "/ltlcustomers",
    "/piaggiocustomers",
    "/lozierstore",
    "/ecolabItems",
  ];

  const getRouteKey = (pathname: string) => {
    const routeSegment = pathname.split("/")[1]?.toLowerCase();

    if (settingsChildRoutes.includes(`/${routeSegment}`)) {
      return "settings";
    }

    // Default case: remove hyphens (for other routes like order-activity)
    return routeSegment?.replaceAll("-", "");
  };

  useEffect(() => {
    setSelectedKey([getRouteKey(location.pathname)]);
  }, [location]);

  return (
    <Scrollbars
      className="scrollerbars"
      renderTrackHorizontal={() => <div style={{ display: "none" }} />}
      renderThumbHorizontal={() => <div style={{ display: "none" }} />}
    >
      <S.Menu mode="vertical" selectedKeys={selectedKey}>
        {menuItemsData
          .filter((item: any) =>
            ["lozier", "piaggio"].every(
              (term) => !item.label?.toLowerCase().includes(term),
            ),
          )
          .map((item: any) => (
            <Menu.Item
              key={item.label?.toLowerCase()?.replaceAll(" ", "")}
              onClick={() => {
                setSelectedKey([
                  item.label?.toLowerCase()?.replaceAll(" ", ""),
                ]);
                navigate(item.path);
                setCollapsed(true);
              }}
              title=""
            >
              <div style={{ textAlign: "center" }}>
                <ReactSVG src={getIconName(item.label)} />
                <Link to={item.path || ""}>{item.label}</Link>
              </div>
            </Menu.Item>
          ))}
      </S.Menu>
    </Scrollbars>
  );
};

export default SiderMenu;
